/** @format */
import { _$ } from '@king-design/react'
import request from 'src/utils/request'

const API = {
  // 修改dashboard
  ModifyDashboard: '/monitor/?Action=ModifyDashboard&Version=2021-01-01',
  // 修改dashboard
  // 创建dashboard
  CreateDashboard: '/monitor/?Action=CreateDashboard&Version=2021-01-01',
  // 删除dashboard
  DeleteDashboard: '/monitor/?Action=DeleteDashboard&Version=2021-01-01',
  // 获取dashboard列表
  ListDashboards: '/monitor/?Action=ListDashboards&Version=2021-01-01',
  // 获取dashboard下graph列表
  DescribeDashboard: '/monitor/?Action=DescribeDashboard&Version=2021-01-01',
  // 删除dashboard下graph
  DeleteDashboardGraph: '/monitor/?Action=DeleteDashboardGraph&Version=2021-01-01',
  // 获取dashboard下graph详情
  DescribeDashboardGraph: '/monitor/?Action=DescribeDashboardGraph&Version=2021-01-01',
  // 获取graph监控项列表
  DescribeDashboardMetrics: '/monitor/?Action=DescribeDashboardMetrics&Version=2021-01-01',
  // 修改graph
  PutDashboardGraph: '/monitor/?Action=PutDashboardGraph&Version=2021-01-01',
  DescribeDashboardMetricsData: '/monitor/?Action=DescribeDashboardMetricsData&Version=2021-01-01',
  getProductList: '/monitor/?Action=DescribeMonitorProductList&Version=2021-01-01', // 获取产品列表UIC接口
  // eslint-disable-next-line max-len
  getDashboardMetricTags: '/monitor/?Action=DescribeDashboardMetricTags&Version=2022-01-01', // 获取监控项下维度列表
  // 获取指标下未匹配维度的资源
  getDashboardInstanceMetricTags:
    '/monitor/?Action=DescribeNoMatchedInstanceMetricTags&Version=2022-01-01 '
}

// 获取指标列表（组）
export const getMetricGroupList = async productType => {
  const result = await request(API.DescribeDashboardMetrics, {
    method: 'post',
    data: {
      ProductType: productType
    }
  })
  if (result.code === 'Success') {
    const metricsGroup = []
    result.data?.metricList.forEach(
      ({ application, metricKey, metricName, units, delay, isDimension }) => {
        const key = application || _$('其它')
        const findIndex = metricsGroup.findIndex(({ app }) => app === key)
        if (findIndex >= 0) {
          metricsGroup[findIndex].children.push({
            metricKey,
            metricName,
            units,
            delay,
            isDimension
          })
        } else {
          metricsGroup.push({
            app: key,
            children: [{ metricKey, metricName, units, delay, isDimension }]
          })
        }
      }
    )
    return metricsGroup
  } else {
    return []
  }
}

// 获取指标下tags
export const getMetricTags = async (productType, metricKey, instances) => {
  const result = await request(API.getDashboardMetricTags, {
    method: 'post',
    data: {
      ProductType: productType,
      MetricKey: metricKey,
      Instances: instances.map(item => item.instanceId)
    }
  })
  if (result.code === 'Success') {
    return result.data.metricTags || []
  } else {
    return []
  }
}

export default API
